import { getCookie, setCookie } from "@workspace/cookies/browser";

const delay = 30 * 1000;

const useResendingEnableTimeCookie = () => {
  const resendingEnableTimeCookie = Number(
    getCookie("enable-sms-resending-time-on") ?? new Date().getTime() + delay,
  );

  const setResendingEnableTimeCookie = () => {
    if (resendingEnableTimeCookie <= new Date().getTime() + delay) {
      setCookie(
        "enable-sms-resending-time-on",
        String(new Date().getTime() + delay),
      );
    }
  };
  return {
    resendingEnableTimeCookie,
    setResendingEnableTimeCookie,
  };
};

export default useResendingEnableTimeCookie;
